// RTK Query tag types and IDs for strategy API
export const ROUTES_TAG_TYPES = {
  ROUTE: 'routes',
} as const;

export const ROUTES_TAG_IDS = {
  ALL_ROUTES: 'ALL_ROUTES',
  USER_ROUTES: 'USER_ROUTES',
  LIST_ROUTES: 'LIST_ROUTES',
} as const;

// Export individual constants for easier use with 'as const'
export const ROUTES_TAG_TYPE = 'Route' as const;
export const ALL_ROUTES_ID = 'ALL_ROUTES' as const;
export const USER_ROUTES_ID = 'USER_ROUTES' as const;
export const LIST_ROUTES_ID = 'LIST_ROUTES' as const;

// Backend caps optimize at 120 stops; routes and stops are fetched in one page
export const MAX_ROUTE_STOPS = 120;
export const ROUTES_PAGE_SIZE = 1000;
